import { OrganizationResponse } from '@/api/api-client';
import { OrganizationViewModel } from '@/api/api-view-models/organization-models.ts';

export const mapOrganizations = (data: OrganizationResponse[]): OrganizationViewModel[] => {
  return data.map(item => ({
    id: item.id,
    name: item.name,
    domain: item.domain,
    assessments: item.assessments,
    verticals: item.verticals,
  }))
}